import React from 'react'
import { DatePicker } from 'antd'
import styles from './ExpiryDateInput.module.css'
import DescriptionVisibleInput from '../DescriptionVisibleInput/DescriptionVisibleInput.js'
import { observer } from 'mobx-react-lite'
import { BuilderContext } from '../../../../store/store.Builder'
import { useContext } from 'react'
import { toJS } from 'mobx'
import dayjs from 'dayjs'

const { RangePicker } = DatePicker

const ExpiryDateInput = observer(({ value = [], onChange }) => {
  const builderContext = useContext(BuilderContext)

  const now = dayjs()
  const twoYearsFromNow = now.add(2, 'year')

  const startDate = builderContext.selectedField.start_date
    ? dayjs(builderContext.selectedField.start_date, 'DD-MM-YYYY HH:mm')
    : now

  const endDate = builderContext.selectedField.end_date
    ? dayjs(builderContext.selectedField.end_date, 'DD-MM-YYYY HH:mm')
    : twoYearsFromNow

  const handleDateChange = (dates, dateStrings) => {
    console.log('Plage de dates:', dateStrings)

    // Vérifiez que les dates sont valides avant de continuer
    if (dates && dates.length === 2) {
      const [start, end] = dateStrings

      // Mise à jour sécurisée des propriétés start_date et end_date
      const updatedField = {
        ...toJS(builderContext.selectedField),
        start_date: start,
        end_date: end,
      }

      console.log('selectedField après mise à jour:', updatedField)
      builderContext.handleFieldUpdate(updatedField)

      // Ici, vous pouvez également déclencher une action pour sauvegarder ces données en back-end si nécessaire
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.switch}>
        <DescriptionVisibleInput value={value} onChange={onChange} />
      </div>
      {value ? (
        <div className={styles.dateRangeContainer}>
          <RangePicker
            value={startDate && endDate ? [startDate, endDate] : []}
            showTime={{ format: 'HH:mm' }}
            format="DD-MM-YYYY HH:mm"
            onChange={handleDateChange}
          />
        </div>
      ) : null}
    </div>
  )
})

export default ExpiryDateInput
